'use strict';

var classNames = {
	screenSizeDetector: 'screen-size-detector'
};

function getScreenSize() {
	return $.findByBem(classNames.screenSizeDetector).css('font-family').toUpperCase();
}

export default {
	getScreenSize: getScreenSize,

	isDesktop() {
		var screenSize = getScreenSize();
		return screenSize === 'L' || screenSize === 'XL' || screenSize === 'XXL';
	},

	isMobile() {
		var screenSize = getScreenSize();
		return screenSize === 'S';
	},

	isIOS() {
		if (!navigator.platform) {
			return false;
		}

		if (/iPad|iPhone|iPod/.test(navigator.platform)) {
			return true;
		}

		if (/MacIntel/.test(navigator.platform)) {
			// iPad iOS 13+ returns same platform as MacBook, so we test touchscreen as hacky workaround
			return !!navigator.maxTouchPoints && navigator.maxTouchPoints > 2;
		}

		return false;
	},

	disablePageScrolling() {
		const scrollbarWidth = window.innerWidth - document.documentElement.clientWidth;
		document.body.style.overflow = 'hidden';
		document.body.style.paddingRight = `${scrollbarWidth}px`;
	},

	enablePageScrolling() {
		document.body.style.overflow = '';
		document.body.style.paddingRight = '';
	},

	automaticallyDisplayOffCanvas(offCanvasSelector) {
		$(document).ready(function () {
			// Timeouts and manual styling to avoid race conditions initialising foundation with react views etc
			window.setTimeout(() => {
				const $offCanvas = $(offCanvasSelector);
				$offCanvas.removeClass('is-closed').addClass('is-open').attr('aria-hidden', 'false');
				$offCanvas.siblings('.js-off-canvas-overlay').addClass('is-visible');
			}, 500);
		});
	}
}